export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN || 'dev-1gn0wqivtuvf8rij.us.auth0.com',
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || 'e4YzhVPNgaQHFjFmS9Fnvi1QEU3NGN06',
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: process.env.REACT_APP_AUTH0_AUDIENCE || 'https://dev-1gn0wqivtuvf8rij.us.auth0.com/api/v2/',
  },
}; 